import React from 'react'
import ChatWidget from 'components/chat/ChatWidget/ChatWidget';

const InAppPage: React.FC = () => {
    return (
        <div>
            <ChatWidget
                {...{
                    closeWidget: () => { },
                    isHomeScreen: false,
                    setIsHomeScreen: () => { },
                    hideHeader: true
                }}
            />
        </div>
    );
};


export default InAppPage;